module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.handleClose),
      expression: "handleClose"
    }],
    class: [_vm.prefixCls]
  }, [_c('div', {
    ref: "reference",
    class: [_vm.prefixCls + '-rel']
  }, [_vm._t("default", [_c('i-input', {
    class: [_vm.prefixCls + '-editor'],
    attrs: {
      "readonly": !_vm.editable || _vm.readonly,
      "disabled": _vm.disabled,
      "size": _vm.size,
      "placeholder": _vm.placeholder,
      "value": _vm.visualValue,
      "icon": _vm.iconType
    },
    on: {
      "on-input-change": _vm.handleInputChange,
      "on-focus": _vm.handleFocus,
      "on-click": _vm.handleIconClick
    },
    nativeOn: {
      "mouseenter": function($event) {
        _vm.handleInputMouseenter($event)
      },
      "mouseleave": function($event) {
        _vm.handleInputMouseleave($event)
      }
    }
  })])], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('Drop', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opened),
      expression: "opened"
    }],
    ref: "drop",
    attrs: {
      "placement": _vm.placement
    }
  }, [_c('div', {
    ref: "picker"
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-048a2ef8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/date-picker/picker.vue
// module id = 589
// module chunks = 1